import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DevToolJobInfo } from '../interfaces/dev-tool-job-info';

@Injectable({
    providedIn: 'root'
})
export class DevToolJobsService {
    private readonly http = inject(HttpClient);


    private readonly baseUrl: string = environment.apiUrl + '/api/v1/devtool';

    getAvailableJobs(): Observable<DevToolJobInfo[]> {
        return this.http.get<DevToolJobInfo[]>(`${this.baseUrl}/jobs`);
    }

    triggerJob(jobKey: string, payload?: string): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/jobs/${jobKey}/trigger`, payload ?? null);
    }
}
